module.exports = __webpack_public_path__ + "static/countess_sansuri-b0104e5dc9c38e24955e71214f54082f.jpeg";